import { isRambleBrand } from "~/common/brand"
import logo from "~/images/landing/logo"
import rambleWordmark from "~/images/brand/ramble-wordmark"

interface BrandWordmark {
  src: string
  width: number
  height: number
  alt: string
  className: string
}

export const getBrandWordmark = (classNames: { ramble: string; chatbcc: string }): BrandWordmark =>
  isRambleBrand()
    ? { ...rambleWordmark, alt: "Ramble", className: classNames.ramble }
    : { ...logo, alt: "ChatBCC", className: classNames.chatbcc }
